var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5996 17L13.8219 13.2156M15.9154 8.15789C15.9154 10.0563 15.1613 11.8769 13.8189 13.2193C12.4765 14.5617 10.6559 15.3158 8.7575 15.3158C6.85911 15.3158 5.03847 14.5617 3.69611 13.2193C2.35374 11.8769 1.59961 10.0563 1.59961 8.15789C1.59961 6.2595 2.35374 4.43886 3.69611 3.0965C5.03847 1.75413 6.85911 1 8.7575 1C10.6559 1 12.4765 1.75413 13.8189 3.0965C15.1613 4.43886 15.9154 6.2595 15.9154 8.15789V8.15789Z",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.9eafd9678591d8c335132d33fb56ed3b.svg";
export { ForwardRef as ReactComponent };